import { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AdminVerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  const styles = {
    wrapper: {
      width: "100vw",
      height: "100vh",
      backgroundColor: "#000",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      zIndex: 9999,
    },
    spinner: {
      width: "48px",
      height: "48px",
      border: "4px solid rgba(255,255,255,0.2)",
      borderTop: "4px solid #fff",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
      marginBottom: "16px",
    },
    text: {
      fontSize: "14px",
      opacity: 0.8,
      letterSpacing: "0.5px",
    },
  };

  useEffect(() => {
    const verify = async () => {
      if (hasRun.current) return;
      hasRun.current = true;

      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admin/verify-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });

        const data = await res.json();

        if (res.ok) {
          toast.success(data.message || "Email verified successfully! Please login.");
        } else {
          toast.error(data.message || "Email verification failed or link expired");
        }
      } catch (err) {
        console.error(err);
        toast.error("Server error while verifying email");
      } finally {
        setTimeout(() => {
          localStorage.removeItem("verificationRole");
          localStorage.removeItem("verificationEmail");
          navigate(`/Admin/login/${process.env.REACT_APP_ADMIN_PATH}/en-list/admin`, { replace: true });
        }, 2000);
      }
    };

    verify();
  }, [token, navigate]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.spinner} />
      <p style={styles.text}>Verifying your email...</p>

      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default AdminVerifyEmail;
